import { render, staticRenderFns } from "./frontListaConseguir.vue?vue&type=template&id=aef3f230&scoped=true&"
import script from "./frontListaConseguir.vue?vue&type=script&lang=js&"
export * from "./frontListaConseguir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef3f230",
  null
  
)

export default component.exports